import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from '@app/@ui/layout/components/header/header.component';
import { NavbarComponent } from '@app/@ui/layout/components/navbar/navbar.component';
import { BannerComponent } from '@app/@ui/layout/components/banner/banner.component';
import {MaterialModule} from '../../../material/material.module';

@NgModule({
  declarations: [NavbarComponent, FooterComponent, HeaderComponent, BannerComponent, NavbarComponent],
  imports: [CommonModule, RouterModule, MaterialModule],
    exports: [NavbarComponent, FooterComponent, HeaderComponent, BannerComponent],
})
export class LayoutModule {}
